import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

import { ReactComponent as Close } from "../../assets/icons/close-black.svg";
import { IRootState } from "../..";
import { setLanding } from "../../features/landing/reducer";

type PropType = {
  onClose: () => void;
};

const SideNavigation = ({ onClose }: PropType) => {
  const landing = useSelector((state: IRootState) => state.landing.value.type);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    {
      to: "/about",
      text: "About Us",
    },
    {
      to: "/faq",
      text: "FAQs",
    },
    {
      to: "/contact",
      text: "Contact",
    },
  ];

  const type = ["customers", "riders", "establishment"];

  const [user, setUser] = useState(landing);

  const onHideMenu = (route?: string) => {
    setTimeout(() => {
      setMenuOpen(false);

      if (route) navigate(route);
      onClose();
    }, 300);
  };

  const onSetUser = (e: any) => {
    // navigate("/");
    const input = e;
    dispatch(
      setLanding({
        type: input,
      })
    );
    setUser(input);
    if (e === "customers") {
      navigate(`/`);
    } else {
      navigate(`/${e}`);
    }
  };
  return (
    <div
      // onClick={() => {
      //   onHideMenu();
      // }}
      className="bg-lightBlack z-[20] fixed top-0 left-0 right-0 bottom-0 transition-all ease-in-out delay-150"
    >
      <div
        className="fixed top-0 bottom-0 right-0 w-[20%] z-[19]"
        onClick={onClose}
      ></div>
      <div className="flex flex-col justify-between w-[80%] nav bg-[#FFFCF9] fixed top-0 bottom-0 left-0  z-[19] ">
        <div className="">
          <div className=" flex justify-end px-3 w-full py-5">
            <Close
              stroke="black"
              fill="black"
              className=""
              onClick={() => onHideMenu()}
            />
          </div>
          <div className="flex flex-col px-8 gap-6 py-4">
            <div className="sub flex flex-col font-medium text-lg items-center gap-10">
              {type.map((item) => (
                <div
                  className={`cursor-pointer capitalize ${
                    user === item ? "text-primary" : ""
                  }`}
                  key={item}
                  onClick={() => {
                    navigate("/");
                    onSetUser(item);
                    onHideMenu();
                  }}
                >
                  {item}
                </div>
              ))}
              {navLinks.map((item) => (
                <Link to={item.to} key={item.to}>
                  {item.text}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNavigation;
